<template lang="pug">
#sliders
  b-carousel(
    id="carousel-0"
    v-model="slide"
    :interval="interval0"
    @sliding-start="onSlideStart"
    @sliding-end="onSlideEnd"
  )
    b-carousel-slide(v-for="img in imgs" :img-src="img.src")
  b-carousel(
    id="carousel-1"
    v-model="slide1"
    :interval="0"
    controls
    @sliding-start="onSlideStart"
    @sliding-end="onSlideEnd"
  )
    b-carousel-slide(v-for="slide in slides" img-blank)
      span {{slide.text}}

    
</template>

<script>
export default {
  name: "Carousel",
  data() {
    return {
      interval0: 3000,
      slide: 0,
      slide1: 0,
      imgs: [
        {
          src:"/assets/Mobile/Section3/carousel/1.jpg"
        },
        {
          src:"/assets/Mobile/Section3/carousel/2.jpg"
        },
        {
          src:"/assets/Mobile/Section3/carousel/3.jpg"
        },
        {
          src:"/assets/Mobile/Section3/carousel/4.jpg"
        },
        {
          src:"/assets/Mobile/Section3/carousel/5.jpg"
        },
        {
          src:"/assets/Mobile/Section3/carousel/6.jpg"
        },
        {
          src:"/assets/Mobile/Section3/carousel/7.jpg"
        },
        {
          src:"/assets/Mobile/Section3/carousel/8.jpg"
        },
        {
          src:"/assets/Mobile/Section3/carousel/9.jpg"
        },
        {
          src:"/assets/Mobile/Section3/carousel/10.jpg"
        },
        {
          src:"/assets/Mobile/Section3/carousel/11.jpg"
        },
        {
          src:"/assets/Mobile/Section3/carousel/12.jpg"
        },
        {
          src:"/assets/Mobile/Section3/carousel/13.jpg"
        },
        {
          src:"/assets/Mobile/Section3/carousel/14.jpg"
        }
      ],
      slides: [
        {
          text: "Las detenciones y liberaciones de los pobladores de El Quemado se caracterizaron por su arbitrariedad. Mientras que algunos permanecieron cautivos por tan solo 30 días, otros fueron liberados sin motivo claro años después."
        },
        {
          text: "El Gobernador Figueroa no otorgó la amnistía de los presos hasta 1978."
        },
        {
          text: "Cuando regresaron los últimos desaparecidos a El Quemado, encontraron su pueblo en ruina económica y con su tejido social gravemente dañado."
        },
        {
          text: " Los pobladores buscaron refundar su pueblo, por quinta ocasión, dejando a un lado las esperanzas de obtener justicia."
        },
        {
          text: "Desde el inicio de la Guerra contra las Drogas en 2006, El Quemado ha sido frecuentado por grupos criminales que desean adueñarse de sus tierras. Esta vulnerabilidad sigue latente."
        },
        {
          text: "Esta no sería la última vez que El Quemado sufriría violencia. Aún inmerso en la pobreza, el pueblo quedó atrapado en el fuego cruzado entre el Ejército y el Ejército Popular Revolucionario, en la década de los noventas."
        },
        {
          text: "Y creó la Fiscalía Especial para Movimientos Sociales y Políticos del Pasado (FEMOSPP) que concluyó en 2007."
        },
        {
          text: "En el año 2000 el PRI fue derrotado por el PAN en las elecciones presidenciales. El gobierno federal de México de 2000 a 2006 prometió investigar y sancionar a los responsables de los “Crímenes del Pasado” perpetrados por gobernantes anteriores."
        },
        {
          text: "Sin embargo, el ejercicio fracasó en su intento de llevar a gobernantes y torturadores a juicio, haciendo concreta la impunidad de los crímenes que se perpetraron contra ciudadanos como los pobladores de El Quemado."
        },
        {
          text: "Ante la insatisfacción de los resultados de la FEMOSPP, en 2012 se decretó la creación de la Comisión de la Verdad del Estado de Guerrero (COMVERDAD)."
        },
        {
          text: "que examinó cientos de expedientes, realizó exhumaciones e integró 512 casos de violaciones a derechos humanos que fueron entregados a la Comisión Ejecutiva de Atención a Víctimas (CEAV)."
        },
        {
          text: "Por otra parte, la violencia actual que se vive en el estado de Guerrero ha cobrado las vidas de algunos familiares de El Quemado, cuestión que ha expuesto a la población a un segundo proceso de victimización, pero ahora a causa de la violencia en el contexto de la Guerra contra las Drogas."
        },
        {
          text: "Actualmente, las causas raíz de las luchas sociales de la región permanecen en El Quemado: vulnerabilidad económica y falta de acceso a derechos humanos como la salud, la educación y la cultura."
        },
        {
          text: "La principal cosecha del poblado, el café, fue impactado a raíz de las inundaciones causadas por los huracanes de 2013, que propiciaron una plaga de roya que obligó a los campesinos a refugiarse en el cultivo del mango, actualmente el único sostén de sus casi 900 habitantes."
        },
        {
          text: "El informe final de la COMVERDAD se publicó en 2014, un documento clave para esclarecer los crímenes perpetrados contra poblaciones como la de El Quemado, pero que a la fecha no ha derivado en acciones penales."
        },
        {
          text: "La insatisfacción de los resultados de la FEMOSPP y la COMVERDAD han expuesto a las víctimas a varios procesos de revictimización. Al no cumplirse múltiples promesas de reparación del daño, las víctimas han tenido que movilizarse con sus propios recursos para seguir con su lucha."
        }
      ]
    };
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    }
  }
};
</script>

<style lang="scss">
#sliders {
  min-height: 100vh;
  padding: 25vh 0;
}
</style>
